import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { ROUTES } from 'constants/Routes';

import RewardApi from 'apis/RewardApi';

import Toaster from 'components/Toaster';
import { REG_EXP } from 'constants/index';
import {
  setRedeemedVoucherCode,
  getRedeemedVoucherCode,
} from 'constants/localStorageManager';

class RedeemVoucher extends Component {
  constructor() {
    super();
    this.state = {
      first_name: '',
      last_name: '',
      email: '',
      emailError: '',
      disableSubmit: false,
    };
  }

  componentDidMount() {
    const { user } = this.props;
    const { first_name, last_name, email } = user;

    this.setState({
      first_name,
      last_name,
      email,
    });
  }

  onChange = (e, key) => {
    this.setState({
      [key]: e.target.value,
    });
  };

  emailValidator = () => {
    const { email } = this.state;

    if (REG_EXP.EMAIL.test(email)) {
      this.setState({
        emailError: '',
      });
      return true;
    }
    this.setState({
      emailError: 'Please enter valid email address',
    });

    return false;
  };

  confirmRedeem = e => {
    e.preventDefault();

    if (!this.emailValidator()) return;

    this.setState({
      emailError: '',
      disableSubmit: true,
    });

    const { user, rewardId, token, reset, history } = this.props;
    const userData = { ...user, ...this.state };

    RewardApi.unauthorizedRedeem(rewardId, userData)
      .then(() => {
        Toaster.getSuccessToaster(
          'check-circle',
          'Congrats! Your voucher has been successfully redeemed. Please enjoy your time with us!'
        );
        const redeemedTokens = getRedeemedVoucherCode() || [];
        setRedeemedVoucherCode([...redeemedTokens, token]);
        setTimeout(() => {
          reset();
          history.push({
            pathname: `${ROUTES.USER_SURVEY_REWARD}`,
            search: `?token=${token}`,
            state: { redirected: true },
          });
        }, 1000);
      })
      .catch(error => {
        Toaster.getFailureToaster(
          error,
          'exclamation-triangle',
          'Your voucher could not be redeemed.'
        );
      })
      .then(() => {
        this.setState({ disableSubmit: false });
      });
  };

  render() {
    const { couponCode } = this.props;
    const {
      first_name,
      last_name,
      email,
      disableSubmit,
      emailError,
    } = this.state;

    return (
      <div className="container mt-3">
        <div className="col-md-6 mx-auto bg-white styled-box-shadow p-5">
          <div className="p-1 d-inline-block">
            <div className="d-inline-block">
              <h5 className="w-100 float-left text-center text-justify font-weight-bold">
                Reedem this Voucher
              </h5>
              <span className="w-100 mt-1 float-left text-center text-justify">
                Enter customers basic information to redeem this voucher.
              </span>
            </div>
            <div className="d-inline-block mt-2 w-100">
              <form className="mt-2">
                <input
                  name="couponCode"
                  value={couponCode}
                  className="form-control height-4"
                  placeholder="Coupon Code"
                  disabled
                />
                <input
                  name="firstName"
                  value={first_name}
                  onChange={e => this.onChange(e, 'first_name')}
                  className="form-control mt-3 height-4"
                  placeholder="First Name"
                />
                <input
                  name="lastName"
                  value={last_name}
                  onChange={e => this.onChange(e, 'last_name')}
                  className="form-control mt-3 height-4"
                  placeholder="Last Name"
                />
                <input
                  name="emailAddress"
                  value={email}
                  onChange={e => this.onChange(e, 'email')}
                  className="form-control mt-3 height-4"
                  placeholder="Email Address"
                  required
                />
                {emailError && (
                  <span className="text-danger">{emailError}</span>
                )}
                <button
                  type="button"
                  className="w-100 mt-3 btn btn-add-new height-4"
                  onClick={this.confirmRedeem}
                  disabled={disableSubmit}
                >
                  Redeem Voucher
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

RedeemVoucher.defaultProps = {
  user: {
    first_name: '',
    last_name: '',
    email: '',
  },
  reset: () => {},
};

RedeemVoucher.propTypes = {
  user: PropTypes.objectOf({
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    email: PropTypes.string,
  }),
  rewardId: PropTypes.string.isRequired,
  token: PropTypes.string.isRequired,
  reset: PropTypes.func,
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
};

export default withRouter(RedeemVoucher);



// WEBPACK FOOTER //
// ./src/components/userSurveyReward/RedeemVoucher.js